import { TableSchema } from '../metadata-schema';
import { dim_vs_vestiging } from './dim_vs_vestiging';

export const dim_orvs_onderwijsresultaat_vestiging: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_orvs_onderwijsresultaat_vestiging",
	"description": "Definitie voor view dim_orvs_onderwijsresultaat_vestiging uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Instellingspecifiek"
	],
	"properties": {
		"orvs_co_brinvest": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"orvs_fk_inst": {
			"type": "number"
		},
		"orvs_fks_vs": {
			"type": "array",
			"items": {
				"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
				"type": "object",
				"schema": dim_vs_vestiging
			}
		},
		"orvs_nm_schooljaar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"orvs_nms_vestiging": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
